(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-actualite"] && !Shopify.designMode) return;
  try {
    

      (() => {
      'use strict';


      /* ==================================================
          Conversion date → timestamp
      ================================================== */

      const getDateValue = (value) => {

          if (!value) return 0;


          const dateValue = value.trim();


          /*
          * Format :
          * JJ/MM/AAAA
          */
          let match = dateValue.match(
          /^(\d{2})\/(\d{2})\/(\d{4})$/
          );


          if (match) {

          const day = Number(match[1]);
          const month = Number(match[2]);
          const year = Number(match[3]);


          return Date.UTC(
              year,
              month - 1,
              day
          );

          }


          /*
          * Format :
          * AAAA-MM-JJ
          */
          match = dateValue.match(
          /^(\d{4})-(\d{2})-(\d{2})$/
          );


          if (match) {

          const year = Number(match[1]);
          const month = Number(match[2]);
          const day = Number(match[3]);


          return Date.UTC(
              year,
              month - 1,
              day
          );

          }


          return 0;

      };



      /* ==================================================
          Initialisation
      ================================================== */

      const initMainPresse = () => {

          const sections = document.querySelectorAll(
          '[data-main-presse]'
          );


          sections.forEach((section) => {

          const grid = section.querySelector(
              '[data-presse-grid]'
          );


          if (!grid) return;


          const items = Array.from(
              grid.querySelectorAll(
              '[data-presse-item]'
              )
          );


          if (!items.length) return;



          /* ==================================================
              Nettoyage
          ================================================== */

          items.forEach((item) => {

              item.removeAttribute(
              'data-presse-rank'
              );


              item.removeAttribute(
              'data-presse-featured'
              );


              item.removeAttribute(
              'data-editorial-featured'
              );

          });



          /* ==================================================
              Tri chronologique

              Plus récent
              ↓
              Plus ancien
          ================================================== */

          items.sort((a, b) => {

              const dateA = getDateValue(
              a.dataset.publicationDate
              );


              const dateB = getDateValue(
              b.dataset.publicationDate
              );


              return dateB - dateA;

          });



          /* ==================================================
              Réorganisation réelle du DOM
          ================================================== */

          items.forEach((item) => {

              grid.appendChild(item);

          });



          /* ==================================================
              Classement + mise en avant

              Featured si :

              1. contenu le plus récent
              OU
              2. toggle "Mettre en avant"
          ================================================== */

          items.forEach((item, index) => {

              const rank = index + 1;


              const manualFeatured =
              item.dataset.manualFeatured === 'true';


              const isNewest =
              rank === 1;


              const isFeatured =
              isNewest || manualFeatured;



              /*
              * Rang chronologique
              */
              item.dataset.presseRank = rank;



              /*
              * Grand carré 2 × 2
              */
              if (isFeatured) {

              item.setAttribute(
                  'data-presse-featured',
                  ''
              );


              item.setAttribute(
                  'data-editorial-featured',
                  ''
              );

              }

          });

          });

      };



      /* ==================================================
          Initialisation page
      ================================================== */

      initMainPresse();



      /* ==================================================
          Éditeur Shopify
      ================================================== */

      document.addEventListener(
          'shopify:section:load',
          initMainPresse
      );


      document.addEventListener(
          'shopify:block:select',
          initMainPresse
      );

      })();

  
  } catch(e) { console.error(e); }
})();
})();
